import { PlayResultWithLog } from "../playResult";
import { IdiotRunLog } from "./idiotRunLog";
import { IdiotSolitaire } from "./idiotSolitaire";

export class IdiotPlayResult extends PlayResultWithLog<IdiotSolitaire, IdiotRunLog> { }
